import { useCallback, useState } from "react";
import { styled } from "styled-components";
import { IPin, pins } from "./data.js";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { RichText } from "../../internal-components/RichText.js";
import { Pin } from "./Pin.js";
import { useIsDesktop } from "../../hooks/useIsDesktop.js";

interface Props {
  text?: string;
}

export const InteractiveMap: React.FC<Props> = ({ text }) => {
  const [_pins, _setPins] = useState<IPin[]>(pins);
  const isDesktop = useIsDesktop({ mobileSize: 960 });

  const setActivePin = useCallback((id: string | null) => {
    _setPins((prevPins) =>
      prevPins.map((pin) => ({
        ...pin,
        active: id === pin.id,
      }))
    );
  }, []);

  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer>
          <Flex>
            <Column className="column-1 mobile">
              {text && (
                <RichText
                  dangerouslySetInnerHTML={{
                    __html: text,
                  }}
                />
              )}
            </Column>
            <Column className="column-2">
              <Map>
                <picture>
                  <source
                    media="(min-width:960px)"
                    srcSet="https://cdn.rubics.as/elteragruppen/6865091c9f575c098c1686e9/v2-kart-egn-desktop.jpg"
                  />
                  <img
                    className="main-image"
                    src="https://cdn.rubics.as/elteragruppen/686508fc9f575c098c167e99/v2-kart-egn-mobil.jpg"
                    alt="Kart med plassering av ElteraGruppen sine kontorer og medlemsbedrifter"
                  />
                </picture>

                {_pins.map((pin) => (
                  <Pin key={pin.id} pin={pin} setActivePin={setActivePin} />
                ))}
                {text && isDesktop && (
                  <TextContainer>
                    <RichText
                      dangerouslySetInnerHTML={{
                        __html: text,
                      }}
                    />
                  </TextContainer>
                )}
              </Map>
            </Column>
          </Flex>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};

const Flex = styled.div`
  display: flex;
  x-align-items: stretch;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.l};

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  &.column-1 {
    display: flex;
    align-items: center;
  }

  &.column-2 {
    width: 100%;
  }
`;

const TextContainer = styled.div`
  position: absolute;
  bottom: 5%;
  background-color: #fff;
  color: var(--swatch2);
  width: 350px;
  z-index: 1;
`;

const Map = styled.div`
  position: relative;
  aspect-ratio: 1.1039659978;
  width: 100%;

  @media (min-width: 600px) {
    flex-direction: row;
  }

  img.main-image {
    width: 100%;
    display: block;
  }
`;

export default InteractiveMap;
